<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md5 lg4>
            <v-layout align-center justify-center>
              <img
                src="@/assets/images/unoapp.png"
                style="width: 250px; height: auto"
                loading="lazy"
              />
            </v-layout>
            <!-- TODO: Check image style -->
            <v-card v-show="showForm" class="elevation-12 px-5">
              <offset-heading
                titleClass="text-center headline font-weight-bold"
                :title="isForgotPassword ? 'FORGOT PASSWORD' : 'LOGIN'"
              />

              <v-card-text class="px-5 py-5 mt-7">
                <v-form
                  ref="loginForm"
                  lazy-validation
                  @submit.prevent="login"
                  onsubmit="return false;"
                >
                  <v-text-field
                    autofocus
                    v-model="user.email"
                    :rules="emailRules"
                    prepend-icon="person"
                    name="login"
                    label="Login"
                    required
                    validate-on-blur
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-if="!isForgotPassword"
                    v-model="user.password"
                    :rules="passwordRules"
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    validate-on-blur
                    :append-icon="
                      showPassword ? 'visibility_off' : 'visibility'
                    "
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                  <!-- TODO: Work on forgot passwornd and phone login -->
                  <div class="px-5">
                    <v-layout justify-center>
                      <span
                        v-if="!isForgotPassword"
                        class="normal-link pointed-cursor"
                        @click="isForgotPassword = true"
                        >Forgot your password?</span
                      >
                      <br />
                    </v-layout>
                    <v-layout justify-center> </v-layout>
                    <br />
                    <v-layout justify-center>
                      <v-btn
                        v-if="isForgotPassword"
                        color="primary"
                        d-inline-flex
                        fab
                        medium
                        @click="isForgotPassword = false"
                      >
                        <v-icon dark>navigate_before</v-icon>
                      </v-btn>

                      <v-btn
                        color="primary"
                        d-inline-flex
                        fab
                        medium
                        type="submit"
                      >
                        <v-icon dark>navigate_next</v-icon>
                      </v-btn>
                    </v-layout>
                  </div>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AuthApi from '@/api/account/auth'
import OffsetHeading from '@/components/OffsetHeading'
import uiHelper from '@/helpers/ui'
import { mapActions } from 'vuex'

export default {
  components: {
    OffsetHeading
  },

  data() {
    return {
      showForm: true,
      showPassword: false,
      isForgotPassword: false,
      user: {
        email: '',
        password: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [v => !!v || 'Password is required'],
      passwordCheckRules: [v => !!v || 'Password is required'],
      step: 1
    }
  },

  methods: {
    ...mapActions({
      unoappLogin: 'auth/login'
    }),

    async login() {
      if (this.isForgotPassword) {
        if (this.user.email !== '') {
          try {
            const response = await AuthApi.forgotPassword({
              email: this.user.email
            })

            uiHelper.showSnackbarMessage(response.data.msg)
            this.user.email = ''
            this.isForgotPassword = false
          } catch (error) {
            uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
            throw error
          }
        }
      } else {
        if (this.$refs.loginForm.validate()) {
          this.showForm = false
          try {
            await this.unoappLogin({
              email: this.user.email,
              password: this.user.password
            })
            this.$router.push({ name: 'Business' })
          } catch {
            this.showForm = true
          }
        }
      }
    }
  }
}
</script>
